import { OrdersService } from "./implementations/orders.service.js";

export default defineNuxtPlugin((nuxtApp) => {
  const orders = new OrdersService(
    nuxtApp.$axios,
    nuxtApp.$config.public.sgApiUrl
  );

  return {
    provide: {
      orders: orders,
    },
  };
});
